import React from "react";

import { Chip as ChipMUI, ChipProps } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import classNames from "classnames";

import useStyles from "./styles";

interface Props extends ChipProps {}

const Chip = (props: Props) => {
  const { disabled, className } = props;

  const classes = useStyles();

  return (
    <ChipMUI
      {...props}
      className={classNames(classes.chip, className)}
      size="small"
      disabled={disabled}
      deleteIcon={!disabled ? <CloseIcon className={classes.closeIcon} fontSize="small" /> : <></>}
    />
  );
};

export default Chip;
